module.exports = __webpack_public_path__ + "static/media/papua-new-guinea.4ebca2be.jpg";